var _rect, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.433594,
    y: 0.784668,
    width: 26.8317,
    height: 26,
    rx: 6,
    fill: "#EDF0F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4328 20.8755C14.0855 20.8755 14.6146 20.3464 14.6146 19.6937V7.87549C14.6146 7.22279 14.0855 6.69367 13.4328 6.69367C12.7801 6.69367 12.251 7.22279 12.251 7.87549V19.6937C12.251 20.3464 12.7801 20.8755 13.4328 20.8755Z",
    fill: "#234596"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3418 13.7847C6.3418 14.4374 6.87091 14.9666 7.52362 14.9666H19.3418C19.9945 14.9666 20.5236 14.4374 20.5236 13.7847C20.5236 13.132 19.9945 12.6029 19.3418 12.6029H7.52362C6.87091 12.6029 6.3418 13.132 6.3418 13.7847Z",
    fill: "#234596"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjciIHZpZXdCb3g9IjAgMCAyOCAyNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC40MzM1OTQiIHk9IjAuNzg0NjY4IiB3aWR0aD0iMjYuODMxNyIgaGVpZ2h0PSIyNiIgcng9IjYiIGZpbGw9IiNFREYwRjUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMy40MzI4IDIwLjg3NTVDMTQuMDg1NSAyMC44NzU1IDE0LjYxNDYgMjAuMzQ2NCAxNC42MTQ2IDE5LjY5MzdWNy44NzU0OUMxNC42MTQ2IDcuMjIyNzkgMTQuMDg1NSA2LjY5MzY3IDEzLjQzMjggNi42OTM2N0MxMi43ODAxIDYuNjkzNjcgMTIuMjUxIDcuMjIyNzkgMTIuMjUxIDcuODc1NDlWMTkuNjkzN0MxMi4yNTEgMjAuMzQ2NCAxMi43ODAxIDIwLjg3NTUgMTMuNDMyOCAyMC44NzU1WiIgZmlsbD0iIzIzNDU5NiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYuMzQxOCAxMy43ODQ3QzYuMzQxOCAxNC40Mzc0IDYuODcwOTEgMTQuOTY2NiA3LjUyMzYyIDE0Ljk2NjZIMTkuMzQxOEMxOS45OTQ1IDE0Ljk2NjYgMjAuNTIzNiAxNC40Mzc0IDIwLjUyMzYgMTMuNzg0N0MyMC41MjM2IDEzLjEzMiAxOS45OTQ1IDEyLjYwMjkgMTkuMzQxOCAxMi42MDI5SDcuNTIzNjJDNi44NzA5MSAxMi42MDI5IDYuMzQxOCAxMy4xMzIgNi4zNDE4IDEzLjc4NDdaIiBmaWxsPSIjMjM0NTk2Ii8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };